export const DAY_CELL_WIDTH = "216px";
export const DAY_CELL_HEIGHT = "180px";
export const LEFT_PANEL_CELL_WIDTH = "248px";
